<template>
    <div class="last-response-cell">
        <span data-test-id="last-response">{{ lastUpdateString }}</span>
        <span data-test-id="last-response-pretty">{{ sinceLastUpdateString }}</span>
    </div>
</template>

<script>
import canToast from '@/mixins/canToast'
import needsOrganizationSlug from '@/mixins/needsOrganizationSlug'

export default {
    mixins: [canToast, needsOrganizationSlug],
    props: ['row'],

    computed: {
        lastUpdateString() {
            if (this.row.latest_health_check_at) {
                return `${this.row.latest_health_check_at} UTC`
            }

            return null
        },
        sinceLastUpdateString() {
            if (this.row.latest_health_check_at) {
                const formatted = window.moment.utc(this.row.latest_health_check_at).fromNow(true)
                return `${formatted} since last Health Check`
            }

            return 'N/A'
        },
    },
}
</script>

<style lang="scss" scoped>
.last-response-cell span {
    display: block;
}
</style>
